import * as React from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function MasteringTheLondonSkyline() {
  return <section id="mastering-the-london-skyline" className="dark bg-background text-foreground relative flex h-screen w-full items-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586109/img/nw_london_luxury_extension_bw.png')] bg-cover bg-fixed bg-center bg-no-repeat grayscale contrast-125 brightness-50" />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/70 to-background/20" />
        {}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,var(--background)_150%)] opacity-80" />
      </div>

      {}
      <div className="container relative z-10 mx-auto px-6 md:px-12 lg:ml-[10%] lg:w-3/4 xl:w-2/3">
        <div className="flex flex-col items-start animate-in fade-in slide-in-from-bottom-8 duration-1000 fill-mode-both">
          {}
          <div className="mb-8 h-1 w-24 bg-primary" />

          <h1 className="mb-6 text-5xl font-black uppercase leading-[1.1] tracking-tighter !text-[hsl(0,0%,100%)] md:text-6xl lg:text-7xl">EXPERT BUILDERs NORTH WEST LONDON</h1>

          <p className="mb-10 max-w-2xl text-lg font-light leading-relaxed text-muted-foreground md:text-xl lg:text-2xl"><strong className="font-semibold !text-[hsl(0,0%,100%)]" data-ast-id="f:/src/pages/NorthWestLondonExpertBuilder/sections/MasteringTheLondonSkyline.tsx|sig:vj2986" data-ast-start="1562" data-ast-end="1820" contenteditable="false">SolidTrust Builders:</strong> The premier loft conversion specialist and home renovations company.</p>

          <div className="flex flex-wrap gap-4">
            <Link to="/LeadGenerationPage">
              <Button size="lg" className="h-14 rounded-none px-8 text-sm font-bold uppercase tracking-widest">CONTACT US</Button>
            </Link>
            <Link to="/LeadGenerationPage">
              
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 z-10 flex -translate-x-1/2 flex-col items-center gap-3 text-primary-foreground/70 transition-opacity hover:text-primary-foreground">
        
        <ChevronDown className="size-6 animate-bounce" strokeWidth={1.5} />
      </div>
    </section>;
}